import React from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Avatar,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
} from '@material-ui/core';
import TitleText from './TitleText';
import BodyText from './BodyText';
function convertH2M(timeInHour) {
	// console.log(timeInHour);
	var timeParts = timeInHour.split(':');
	return Number(timeParts[0]) * 60 + Number(timeParts[1]);
}
function timeConvert(n) {
	var num = n;
	var hours = num / 60;
	var rhours = Math.floor(hours);
	var minutes = (hours - rhours) * 60;
	var rminutes = Math.round(minutes);
	return rhours + ' hr and ' + rminutes + ' min.';
}
const SelectedOnwardEtravRow = ({ i, index }) => {
	return (
		<>
			<Box
				display='flex'
				justifyContent='space-between'
				mt={index > 0 ? '20px' : ''}>
				<Box display='flex' alignItems='center'>
					<Box alignItems='center' display='flex'>
						<TitleText
							textStyle={{
								fontFamily: 'unset',
								fontWeight: 500,
								fontSize: 18,
							}}>
							{i.Origin}
						</TitleText>
						-
						<TitleText
							textStyle={{
								fontFamily: 'unset',
								fontWeight: 500,
								fontSize: 18,
							}}>
							{i.Destination}
						</TitleText>
					</Box>
					<Box
						ml={'30px'}
						style={{
							background: 'rgb(239, 51, 57)',
							padding: '3px 15px',
							borderRadius: '50px',
							color: 'white',
							fontFamily: 'unset',
							fontWeight: 500,
						}}>
						<TitleText two>ONWARD</TitleText>
					</Box>
				</Box>
				<Box>
					<BodyText>Fare Rule</BodyText>
				</Box>
			</Box>
			<Box mt={'20px'}>
				<BodyText>{i.TravelDate}</BodyText>
			</Box>
			<Box
				style={{
					background: 'white',
					padding: '10px 15px',
					border: '1px solid #e6e6e6',
					marginTop: '10px',
					borderRadius: 5,
				}}>
				<Grid container>
					<Grid item xs={12} sm={9} lg={9}>
						<Box display='flex' justifyContent='space-between'>
							<Box>
								<TitleText
									textStyle={{
										fontFamily: 'unset',
										fontWeight: 500,
										fontSize: 18,
									}}>
									{i.Origin_City}({i.Origin})
								</TitleText>
								<BodyText
									two
									textStyle={{
										fontFamily: 'unset',
										fontWeight: 600,
										fontSize: 12,
									}}>
									{/* {i.Origin.Airport.AirportName}, T-3 */}
								</BodyText>
							</Box>
							<Box>
								<TitleText
									textStyle={{
										fontFamily: 'unset',
										fontWeight: 500,
										fontSize: 18,
									}}>
									{i.Departure_DateTime.substr(11, 5)}
								</TitleText>
							</Box>
						</Box>
						<Grid container alignItems='center'>
							<Grid item xs={6} lg={9}>
								<Divider />
							</Grid>
							<Grid item xs={4} lg={3}>
								<Box
									style={{
										padding: '2px 20px',
										background: 'rgb(239, 51, 57)',
										color: 'white',
										borderRadius: 5,
									}}>
									<BodyText three>
										{timeConvert(convertH2M(i.Duration))}
									</BodyText>
								</Box>
							</Grid>
						</Grid>

						<Box display='flex' justifyContent='space-between'>
							<Box>
								<TitleText
									textStyle={{
										fontFamily: 'unset',
										fontWeight: 500,
										fontSize: 18,
									}}>
									{i.Destination_City}({i.Destination})
								</TitleText>
								<BodyText
									two
									textStyle={{
										fontFamily: 'unset',
										fontWeight: 600,
										fontSize: 12,
									}}>
									{/* {i.Destination.Airport.AirportName}, T-3 */}
								</BodyText>
							</Box>
							<Box>
								<TitleText
									textStyle={{
										fontFamily: 'unset',
										fontWeight: 500,
										fontSize: 18,
									}}>
									{i.Arrival_DateTime.substr(11, 5)}
								</TitleText>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12} sm={3} lg={3}>
						<Box textAlign='center'>
							<img
								src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
								width='50px'
								height='25px'></img>
							<BodyText three>{i.Airline_Name}</BodyText>
							<BodyText three>
								{i.Airline_Code}-{i.Flight_Number}| Economy
							</BodyText>
							<BodyText three>Check-In : 1Pc - 15Kgs</BodyText>
							<BodyText three>Cabin : 7Kgs</BodyText>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export default SelectedOnwardEtravRow;
